import { Stack } from '@mui/material';

import { transcriptionTypeOptions } from './constants';
import { BlockSelectField } from '../../ConfigFields/SelectField';
import { BlockTextField } from '../../ConfigFields/TextField';

export function VoiceTranscribeFormFields() {
  return (
    <Stack spacing={2}>
      <BlockTextField
        fieldName="config.storagePath"
        label="Cloud Storage Path"
        required
        helperText="Cloud storage path to the voice recording file."
      />
      <BlockSelectField
        fieldName="config.transcriptionType"
        label="Transcription Type"
        options={transcriptionTypeOptions}
        helperText={`Whether this is a recording of a "Dictation" or a "Conversation". Dictation is a single speaker, usually dictating a clinical note. Conversation is between two speakers, usually a provider and a patient.`}
        required
      />
    </Stack>
  );
}
